import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { BarChart3, Loader2 } from 'lucide-react';

const SEL = 'bg-slate-800 border border-slate-600 rounded-lg px-3 py-2 text-sm text-white';

export const ArgumentRanking = ({ refreshKey }) => {
  const { api } = useAuth();
  const [court, setCourt] = useState('');
  const [judge, setJudge] = useState('');
  const [data, setData] = useState(null);

  useEffect(() => {
    setData(null);
    api.get('/experts/ranking/arguments', { params: { court: court || undefined, judge: judge || undefined } }).then((r) => setData(r.data)).catch(() => setData({ ranking: [], courts: [], judges: [], cases_with_outcome: 0 }));
  }, [court, judge, refreshKey, api]);

  return (
    <section data-testid="argument-ranking-section" className="bg-slate-900/60 border border-slate-700 rounded-2xl p-6 mb-10">
      <h2 className="text-lg font-bold flex items-center gap-2 mb-1"><BarChart3 className="w-5 h-5 text-cyan-400" />Ranking de argumentos notariales</h2>
      <p className="text-xs text-slate-400 mb-4">Qué argumentos ganan más veces, según el tribunal y el ministro. Se calcula con los casos con resultado conocido.</p>
      <div className="flex flex-wrap gap-3 mb-4">
        <select data-testid="ranking-court-select" value={court} onChange={(e) => setCourt(e.target.value)} className={SEL}>
          <option value="">Todos los tribunales</option>
          {(data?.courts || []).map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
        <select data-testid="ranking-judge-select" value={judge} onChange={(e) => setJudge(e.target.value)} className={SEL}>
          <option value="">Todos los ministros</option>
          {(data?.judges || []).map((j) => <option key={j} value={j}>{j}</option>)}
        </select>
      </div>
      {!data ? (
        <p className="text-sm text-slate-400 flex items-center gap-2"><Loader2 className="w-4 h-4 animate-spin" />Calculando ranking...</p>
      ) : data.ranking.length === 0 ? (
        <p data-testid="ranking-empty" className="text-sm text-slate-500">Aún no hay casos con resultado para este filtro. Sube sentencias de los expertos para construir el ranking.</p>
      ) : (
        <div data-testid="ranking-list" className="space-y-2">
          <p className="text-xs text-slate-500">{data.cases_with_outcome} caso(s) con resultado conocido</p>
          {data.ranking.map((r, i) => (
            <div key={r.category} data-testid={`ranking-row-${i}`} className="flex items-center gap-3">
              <span className="w-6 text-sm text-slate-500">{i + 1}</span>
              <span className="w-72 text-sm text-slate-200 truncate" title={r.category}>{r.category}</span>
              <div className="flex-1 h-2 bg-slate-700 rounded-full overflow-hidden"><div className={`h-full ${r.win_rate >= 0.6 ? 'bg-green-500' : r.win_rate >= 0.4 ? 'bg-yellow-500' : 'bg-red-500'}`} style={{ width: `${Math.round(r.win_rate * 100)}%` }} /></div>
              <span className="w-12 text-right text-sm font-semibold">{Math.round(r.win_rate * 100)}%</span>
              <span className="w-24 text-right text-xs text-slate-500">{r.won}/{r.used} ganados</span>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};
